export default {"src":"/_next/static/media/ico_setting.f711d981.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};